import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/ribeiro/Development/card-component-module/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { useState } from 'react';
import { Props, Playground } from 'docz';
import Card from './src/lib';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2 {...{
      "id": "introduction"
    }}>{`Introduction`}</h2>
    <p>{`Card Component is a react component that creates a rounded card based on Material Design style guide.`}</p>
    <p><img alt="demogif" src={require("./src/lib/assets/demo.gif")} /></p>
    <h2 {...{
      "id": "instalation"
    }}>{`Instalation`}</h2>
    <p>{`You can install it using `}<inlineCode parentName="p">{`yarn`}</inlineCode>{` or `}<inlineCode parentName="p">{`npm`}</inlineCode></p>
    <p>{`Using `}<inlineCode parentName="p">{`yarn`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{}}>{`yarn add @redwallsolutions/card-component-module
`}</code></pre>
    <p>{`Using `}<inlineCode parentName="p">{`npm`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm install @redwallsolutions/card-component-module
`}</code></pre>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <Props of={Card} mdxType="Props" />
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <h3 {...{
      "id": "simplest-form"
    }}>{`Simplest Form`}</h3>
    <Playground __position={1} __code={'<Card>Hello</Card>'} __scope={{
      props,
      DefaultLayout,
      useState,
      Props,
      Playground,
      Card
    }} mdxType="Playground">
	<Card mdxType="Card">Hello</Card>
    </Playground>
    <h3 {...{
      "id": "header-text"
    }}>{`Header Text`}</h3>
    <Playground __position={2} __code={'<Card headerText=\"Some Card Header\" />'} __scope={{
      props,
      DefaultLayout,
      useState,
      Props,
      Playground,
      Card
    }} mdxType="Playground">
	<Card headerText="Some Card Header" mdxType="Card" />
    </Playground>
    <h3 {...{
      "id": "header-text-and-sub-head"
    }}>{`Header Text and Sub Head`}</h3>
    <Playground __position={3} __code={'<Card headerText=\"Awesome Header\" subHead=\"I\'m awesome too :)\" />'} __scope={{
      props,
      DefaultLayout,
      useState,
      Props,
      Playground,
      Card
    }} mdxType="Playground">
	<Card headerText="Awesome Header" subHead="I'm awesome too :)" mdxType="Card" />
    </Playground>
    <h3 {...{
      "id": "menu-options"
    }}>{`Menu Options`}</h3>
    <Playground __position={4} __code={'<Card headerText=\"I have a menu\" menuOptions={[{ text: \'Some Option\' }]} />'} __scope={{
      props,
      DefaultLayout,
      useState,
      Props,
      Playground,
      Card
    }} mdxType="Playground">
	<Card headerText="I have a menu" menuOptions={[{
        text: 'Some Option'
      }]} mdxType="Card" />
    </Playground>
    <h3 {...{
      "id": "media"
    }}>{`Media`}</h3>
    <Playground __position={5} __code={'<Card headerText=\"Some Media\" media=\"https://picsum.photos/300\" />'} __scope={{
      props,
      DefaultLayout,
      useState,
      Props,
      Playground,
      Card
    }} mdxType="Playground">
	<Card headerText="Some Media" media="https://picsum.photos/300" mdxType="Card" />
    </Playground>
    <h3 {...{
      "id": "supporting-text"
    }}>{`Supporting Text`}</h3>
    <Playground __position={6} __code={'<Card\n  headerText=\"Supporting Text\"\n  supportingText=\"A nice supporting text here. It\'s commonly used to describe some item etc.\"\n/>'} __scope={{
      props,
      DefaultLayout,
      useState,
      Props,
      Playground,
      Card
    }} mdxType="Playground">
	<Card headerText="Supporting Text" supportingText="A nice supporting text here. It's commonly used to describe some item etc." mdxType="Card" />
    </Playground>
    <h3 {...{
      "id": "only-actions"
    }}>{`Only Actions`}</h3>
    <Playground __position={7} __code={'<Card\n  actions={[{ text: \'Cancel\' }, { text: \'Save\', variant: \'contained\' }]}\n/>'} __scope={{
      props,
      DefaultLayout,
      useState,
      Props,
      Playground,
      Card
    }} mdxType="Playground">
	<Card actions={[{
        text: 'Cancel'
      }, {
        text: 'Save',
        variant: 'contained'
      }]} mdxType="Card" />
    </Playground>
    <h3 {...{
      "id": "complete-card-dark-and-light-mode"
    }}>{`Complete Card (Dark and Light mode)`}</h3>
    <Playground __position={8} __code={'() => {\n  const [mode, setMode] = useState(\'light\')\n  return (\n    <div>\n      <Card\n        theme={{ mode }}\n        menuOptions={[\n          {\n            text: \'Dark Mode\',\n            handler: () => {\n              setMode(\'dark\')\n            },\n          },\n          {\n            text: \'Light Mode\',\n            handler: () => {\n              setMode(\'light\')\n            },\n          },\n        ]}\n        headerText=\"It\'s a material design card\"\n        subHead=\"Aimed to display important data.\"\n        media=\"https://picsum.photos/300\"\n        actions={[\n          { text: \'Cancel\' },\n          { text: \'Save\', appearance: \'default\', variant: \'contained\' },\n        ]}\n        supportingText=\"You can do anything you want.\"\n      />\n    </div>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      useState,
      Props,
      Playground,
      Card
    }} mdxType="Playground">
	{() => {
        const [mode, setMode] = useState('light');
        return <div>
					<Card theme={{
            mode
          }} menuOptions={[{
            text: 'Dark Mode',
            handler: () => {
              setMode('dark');
            }
          }, {
            text: 'Light Mode',
            handler: () => {
              setMode('light');
            }
          }]} headerText="It's a material design card" subHead="Aimed to display important data." media="https://picsum.photos/300" actions={[{
            text: 'Cancel'
          }, {
            text: 'Save',
            appearance: 'default',
            variant: 'contained'
          }]} supportingText="You can do anything you want." mdxType="Card" />
				</div>;
      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      